// src/utils/immersive.js
//
// Полноэкранный режим кассы-планшета.
// APK: свой плагин Immersive (MainActivity) прячет строку состояния и кнопки Android.
// Веб: Fullscreen API — браузер разрешает войти только по нажатию, поэтому вход
// вызываем прямо из обработчика кнопки «Планшет»; выйти можно всегда.

import { Capacitor, registerPlugin } from '@capacitor/core';

const Immersive = registerPlugin('Immersive');

export const isNative = () => Capacitor.isNativePlatform();

export async function setImmersive(on) {
  try {
    if (isNative()) {
      await Immersive.set({ on: !!on });
      return;
    }
    const doc = document;
    if (on) {
      if (!doc.fullscreenElement && doc.documentElement.requestFullscreen) {
        await doc.documentElement.requestFullscreen();
      }
    } else if (doc.fullscreenElement && doc.exitFullscreen) {
      await doc.exitFullscreen();
    }
  } catch (e) {
    // старый APK без плагина / браузер не дал — просто остаёмся как есть
  }
}
